import zh from './zh.json';
import en from './en.json';

export const langResources = {
  'zh': {
    translation: zh,
  },
  'en': {
    translation: en,
  },
};
